import React from 'react'
import { l } from '@manychat/manyui'

import { getContentPartKey } from 'common/builder/components/chart/FlowChart/components/Block/components/TextContent/getContentPartKey'
import { TextContentPart } from 'common/builder/components/chart/FlowChart/components/Block/components/TextContent/TextContentPart'
import { ContentPart } from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

interface TextBlockContentProps {
  content: ContentPart[] | null
  buttons: FlowChartButton[]
}

export const TextContent = ({ content, buttons }: TextBlockContentProps) => {
  const emptyText = l.translate('Add a text')

  if (!content) {
    return <TextWithIcon empty>{emptyText}</TextWithIcon>
  }

  return (
    <>
      {content.map((contentPart, index) => (
        <TextContentPart
          contentPart={contentPart}
          buttons={buttons}
          key={getContentPartKey(contentPart, index)}
        />
      ))}
    </>
  )
}
